import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Footer from './Components/footer/footer';
import Header from './Components/header/header';
import Console from './Context/console';
import Tree from './pages/tree/tree';
import Toys from './pages/toys/toys';
import Main from './pages/main/main';
import { AppContext } from './Context/app-state';

// eslint-disable-next-line func-names
const App = () => {
  const { toysOnTree, setToysOnTree } = React.useContext(AppContext);
  const drop = (e: React.DragEvent<HTMLDivElement>) => {
    const { id, dataset } = JSON.parse(e.dataTransfer.getData('data'));
    const tempArr = [...toysOnTree];
    const index = tempArr.findIndex(
      (el) => el.id === id && el.index === dataset.index,
    );
    if (index !== -1) tempArr.splice(index, 1);
    const target = (e.target as HTMLDivElement).id;
    if (target === 'tree-map-area') {
      setToysOnTree([
        ...tempArr,
        {
          id,
          x: e.clientX,
          y: e.clientY,
          index: dataset.index,
        },
      ]);
    } else setToysOnTree([...tempArr]);
  };
  return (
    <div className="App" onDragOver={(e) => e.preventDefault()} onDrop={drop}>
      <Header />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/toys" element={<Toys />} />
        <Route path="tree" element={<Tree />} />
      </Routes>
      <Footer />
    </div>
  );
};
const vyvodVConsole = Console();
console.log(`Самооценка: ${vyvodVConsole}`);
export default App;
